"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _usePkpass2 = require("../usePkpass");

var _pkpass = require("../../../../types/pkpass");

var _reactJss = require("react-jss");

var _Theme = require("../../Theme");

var _createUseStyles;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _reactJss.createUseStyles)((_createUseStyles = {}, _defineProperty(_createUseStyles, _pkpass.ImageTypes.logo, {
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'relative',
  width: function width(_ref) {
    var theme = _ref.theme;
    return theme.scale * 148;
  },
  marginLeft: function marginLeft(_ref2) {
    var theme = _ref2.theme;
    return theme.scale * 12;
  },
  height: function height(_ref3) {
    var theme = _ref3.theme;
    return theme.scale * 44;
  },
  maxWidth: function maxWidth(_ref4) {
    var theme = _ref4.theme;
    return theme.scale * 148;
  },
  maxHeight: function maxHeight(_ref5) {
    var theme = _ref5.theme;
    return theme.scale * 44;
  },
  float: 'left'
}), _defineProperty(_createUseStyles, _pkpass.ImageTypes.strip, {
  width: 320,
  height: function height(_ref6) {
    var theme = _ref6.theme,
        passStyle = _ref6.passStyle;
    return passStyle === _pkpass.PkpassPassStyleTypes.Coupon || passStyle === _pkpass.PkpassPassStyleTypes.StoreCard ? theme.scale * 122 : theme.scale * 84;
  },
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center'
}), _defineProperty(_createUseStyles, _pkpass.ImageTypes.icon, {
  width: function width(_ref7) {
    var theme = _ref7.theme;
    return theme.scale * 29;
  },
  height: function height(_ref8) {
    var theme = _ref8.theme;
    return theme.scale * 29;
  },
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'relative'
}), _defineProperty(_createUseStyles, _pkpass.ImageTypes.footer, {
  width: function width(_ref9) {
    var theme = _ref9.theme;
    return theme.scale * 300;
  },
  height: function height(_ref10) {
    var theme = _ref10.theme;
    return theme.scale * 20;
  },
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  backgroundPosition: 'center',
  backgroundSize: 'cover'
}), _defineProperty(_createUseStyles, _pkpass.ImageTypes.thumbnail, {
  width: function width(_ref11) {
    var theme = _ref11.theme;
    return theme.scale * 90;
  },
  height: function height(_ref12) {
    var theme = _ref12.theme;
    return theme.scale * 90;
  },
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'relative'
}), _defineProperty(_createUseStyles, _pkpass.ImageTypes.background, {
  width: function width(_ref13) {
    var theme = _ref13.theme;
    return theme.scale * 360;
  },
  height: function height(_ref14) {
    var theme = _ref14.theme;
    return theme.scale * 440;
  },
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
  position: 'relative'
}), _defineProperty(_createUseStyles, "container", {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '&:hover': {
    cursor: function cursor(_ref15) {
      var clickable = _ref15.clickable;
      return clickable ? 'pointer' : undefined;
    },
    opacity: function opacity(_ref16) {
      var clickable = _ref16.clickable;
      return clickable ? 0.7 : undefined;
    }
  }
}), _createUseStyles));

var ImagePreview = function ImagePreview(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      passStyle = _usePkpass.passStyle,
      language = _usePkpass.language,
      images = _usePkpass.images,
      onImageClick = _usePkpass.onImageClick;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme,
    passStyle: passStyle,
    clickable: !!onImageClick
  });
  var id = images ? images[props.imageType] : undefined;
  var idStr;

  if (id && typeof id != 'string') {
    idStr = id[language];
  } else {
    idStr = id;
  }

  if (!idStr) {
    return /*#__PURE__*/React.createElement("div", {
      className: classes[props.imageType]
    });
  }

  var url = idStr;
  var style = {
    backgroundImage: "url(".concat(url, ")")
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container,
    onClick: onImageClick ? function (event) {
      onImageClick(props.imageType, event);
    } : undefined
  }, /*#__PURE__*/React.createElement("div", {
    style: style,
    className: classes[props.imageType]
  }));
};

var _default = ImagePreview;
exports.default = _default;
//# sourceMappingURL=ImagePreview.js.map